module.exports = __webpack_public_path__ + "static/media/notice.548dd1c2.JPG";